import { Link } from "react-router-dom";
import Ornament from "@/components/Ornament";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-brand-deep border-t border-brand-gold/15 mt-0"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand */}
          <div>
            <span className="block text-[10px] tracking-[0.4em] uppercase text-brand-gold/70 mb-2 font-sans">
              Est. 1932 · Bucureşti
            </span>
            <h3 className="font-serif italic text-3xl text-brand-gold leading-tight">
              La Maison Dorée
            </h3>
            <p className="mt-4 font-serif italic text-brand-ivory/60 text-base leading-relaxed max-w-xs">
              Rafinament în fiecare detaliu.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="h-px w-10 bg-brand-gold/40" />
              <span className="text-[10px] tracking-[0.35em] uppercase text-brand-gold/60">
                Maison Française
              </span>
            </div>
          </div>

          {/* Links */}
          <div className="md:pl-8">
            <span className="block text-[10px] tracking-[0.35em] uppercase text-brand-gold mb-5 font-sans">
              Navigare
            </span>
            <ul className="space-y-3 font-sans text-[15px]">
              {[
                { to: "/", label: "Acasă" },
                { to: "/meniu", label: "Meniu" },
                { to: "/galerie", label: "Galerie" },
                { to: "/rezervari", label: "Rezervări" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-brand-ivory/75 hover:text-brand-gold transition-colors duration-300 inline-flex items-center gap-3 group"
                  >
                    <span className="h-px w-4 bg-brand-gold/40 group-hover:w-8 group-hover:bg-brand-gold transition-all duration-300" />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <span className="block text-[10px] tracking-[0.35em] uppercase text-brand-gold mb-5 font-sans">
              Contact
            </span>
            <ul className="space-y-4 font-sans text-[14px] text-brand-ivory/75">
              <li className="flex gap-3">
                <MapPin size={16} className="text-brand-gold flex-shrink-0 mt-0.5" strokeWidth={1.4} />
                <span>Strada Franceză 14, Centrul Istoric, Bucureşti</span>
              </li>
              <li className="flex gap-3">
                <Phone size={16} className="text-brand-gold flex-shrink-0 mt-0.5" strokeWidth={1.4} />
                <a href="tel:+40721234567" className="hover:text-brand-gold transition-colors">
                  +40 721 234 567
                </a>
              </li>
              <li className="flex gap-3">
                <Mail size={16} className="text-brand-gold flex-shrink-0 mt-0.5" strokeWidth={1.4} />
                <a href="mailto:contact@lamaisondoree.ro" className="hover:text-brand-gold transition-colors">
                  contact@lamaisondoree.ro
                </a>
              </li>
              <li className="flex gap-3">
                <Clock size={16} className="text-brand-gold flex-shrink-0 mt-0.5" strokeWidth={1.4} />
                <span>
                  Luni–Sâmbătă · 12:00 – 23:00<br />
                  Duminică · 12:00 – 21:00
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16">
          <Ornament />
        </div>

        <div className="mt-8 flex flex-col md:flex-row items-center justify-between gap-3 text-[12px] tracking-[0.2em] uppercase text-brand-ivory/40 font-sans">
          <span data-testid="footer-copyright">© 2025 La Maison Dorée. Toate drepturile rezervate.</span>
          <span className="text-brand-gold/60 italic font-serif tracking-normal text-sm normal-case">
            Bucureşti · Paris · Lyon
          </span>
        </div>
      </div>
    </footer>
  );
}
